module.exports = __webpack_public_path__ + "fonts/gothica1-thin-webfont.e8595e3.woff";